import styled from 'styled-components';
import { colors, s16, s32 } from '@ardoq/design-tokens';
import { header4 } from '@ardoq/typography';

export const SidebarMenuEmptyContent = styled.div`
  text-align: center;
  ${header4}
  padding: ${s32} ${s16};
  color: ${colors.grey950};
`;
